import React from "react";
import InnerHaeder from "../Component/InnerHaeder";
import Highlights from "../Component/Highlights";
import Footer from "../Component/Footer";
import { Link } from "react-router-dom";
import HeadTag from "../Component/HeadTags";
import LazyLoad from "react-lazyload";
const Curriculum = () => {
  return (
    <>
      <HeadTag title="Curriculum" />
      <Highlights />
      <InnerHaeder />
      <div className="inner_page lotusvalley_para">
        <div className="container-fluid flwidth">
          <div className="bgimage">
            <h5>
              <Link to="/">
                {" "}
                Home <i className="fas fa-angle-right"></i>{" "}
              </Link>
              <span>
                {" "}
                Academics <i className="fas fa-angle-right"></i> Curriculum{" "}
              </span>
            </h5>
            <h2>Curriculum</h2>
          </div>
          <div className="row">
            <div className="col-lg-12 col-md-12">
              <LazyLoad>
                {" "}
                <img
                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGN/public/Images/about.jpg"
                  className="inner_img img-fluid"
                  alt="Lotus Valley International School, Greater Noida"
                />
              </LazyLoad>
              <p>
                Curriculum at LVIS, NE is a sum total of educational experiences
                with clear Learning Objectives, Courses of Study, Pedagogical
                Practices and Assessment guidelines. It seeks to provide
                opportunities to learners for physical, intellectual and social
                development; enhance self-awareness and explore innate
                potential; promote life skills & inculcate values; strengthen
                knowledge, skills attitude & promote physical fitness, health &
                wellbeing.{" "}
              </p>
              <h3>Foundational (Classes Nursery - 2)</h3>
              <h3>Curriculum Overview: Planting Roots for Lifelong Learning</h3>
              <p>
                At Lotus Valley International School, Noida Extension, we view
                the early years as a golden window—a time when children are most
                curious, most impressionable, and most capable of deep, joyful
                learning. Our foundational curriculum is designed not just to
                prepare learners for school, but to prepare them for life.
                Rooted in the principles of the National Education Policy (NEP)
                2020, and inspired by the national mission on Foundational
                Literacy and Numeracy (FLN), our approach is intentional,
                integrated, and innovative. Every learning experience—whether
                through play, conversation, movement, or exploration—is
                carefully curated to nurture essential competencies across all
                domains of development. Here, children don’t just learn—they
                thrive.
              </p>
              <p>
                With a strong emphasis on holistic development and 21st-century
                skills, our curriculum empowers young learners with the
                creativity, critical thinking, collaboration, and character
                needed to flourish in a dynamic world. It lays the groundwork
                for lifelong learning through the seamless integration of core
                competencies across cognitive, emotional, physical, and creative
                spheres.
              </p>
              <p>
                <strong>Language and Literacy Development</strong>: Language is
                the heartbeat of learning. It enables expression, builds
                identity, and fosters connection. Our curriculum builds strong
                literacy foundations through immersive, experience-based
                approaches that support speaking, listening, reading, and early
                writing. Children are encouraged to articulate their thoughts,
                explore new vocabulary, comprehend meaning, and engage with a
                variety of oral and written forms. This domain caters to key
                competencies such as phonological awareness, vocabulary
                expansion, sentence structuring, listening comprehension, and
                emergent literacy skills. In alignment with NEP 2020, the focus
                remains on nurturing confident communicators who can engage
                meaningfully in a multilingual world.
              </p>
              <p>
                <strong>Cognitive Development and Foundational Numeracy</strong>
                : In a world fuelled by innovation and analytical thinking, the
                foundations of reasoning must be laid early. Our curriculum
                cultivates essential intellectual abilities such as curiosity,
                logical thinking, observation, memory retention, spatial
                understanding, and early numeracy. Learners engage with
                patterns, quantities, measurements, and sequencing through
                immersive, hands-on experiences that make abstract concepts
                tangible and meaningful. By integrating real-life contexts, we
                nurture a sense of inquiry and independent judgment, enabling
                children to develop conceptual clarity and flexible
                problem-solving strategies. In alignment with the Foundational
                Literacy and Numeracy (FLN) mission under NEP 2020, this domain
                equips learners with enduring cognitive skills that serve as the
                groundwork for mathematical fluency, critical analysis, and
                lifelong rational thinking.
              </p>
              <p>
                <strong>Physical and Motor Development</strong>: Physical
                development in the early years lays the groundwork for
                confident, active learners. Our curriculum integrates purposeful
                movement with learning, nurturing both gross and fine motor
                skills essential for coordination, balance, agility, and spatial
                awareness. Through thoughtfully designed experiences, children
                build physical stamina, body control, and self-regulation—skills
                that directly support focus, independence, and overall cognitive
                growth. Alongside movement, we introduce learners to the
                importance of healthy food choices and daily habits that
                contribute to strength, vitality, and well-being. This holistic
                approach empowers children to not only move with confidence but
                also understand the value of caring for their
                bodies—establishing lifelong patterns of physical fitness and
                mindful living
              </p>
              <p>
                <strong>Socio-Emotional Development</strong>: Emotional strength
                is as vital as academic success. We nurture children’s ability
                to understand themselves, relate to others, and manage their
                emotions with care and empathy. Through guided experiences and
                intentional peer interactions, learners develop socio-emotional
                competencies such as self-awareness, responsible
                decision-making, emotional regulation, and
                relationship-building. The curriculum provides a secure,
                respectful space where children feel valued, heard, and
                empowered. In alignment with NEP 2020, this domain builds the
                foundation for ethical citizenship, resilience, collaboration,
                and the emotional intelligence required to navigate an
                interconnected world.
              </p>
              <p>
                <strong> Creative and Aesthetic Development</strong>:
                Imagination is a child’s earliest way of making sense of the
                world, and creativity is the language through which they express
                it. Our curriculum nurtures this natural spark by offering rich
                opportunities in visual art, music, storytelling, movement, and
                dramatic play. Within these expressive spaces, children develop
                essential creative abilities such as divergent thinking,
                visual-spatial understanding, symbolic expression, and a deep
                appreciation for aesthetics. These experiences encourage
                originality, confidence in self-expression, and a willingness to
                explore new perspectives. By engaging with their senses,
                emotions, and ideas, learners cultivate a lasting connection
                with creativity—one that fuels innovation, curiosity, and joy
                throughout their lives.
              </p>
              {/* <h3>Foundational (Classes Nursery - 2 )</h3>

<p>The early years play a key role in children's brain development. Children's early experiences, the bonds they form with their parents and their first learning experiences, deeply affect their future physical, cognitive, emotional and social development.</p>
<p>Enabling the environment plays a key role in supporting and extending children’s development and learning. When children feel emotionally safe and secure, they are able to explore and find out about the place they are in and the things they can see, touch, or manipulate.</p>  

<p>Simple games of peek-a-boo, shaking a rattle or singing a song are much more important than just a way to pass the time. They teach young children about communication, develop their motor skills and help with problem-solving. Something as easy as stacking and knocking over blocks allows toddlers to discover math and science concepts, including shapes, gravity, balance and counting.</p>

<p>These early childhood games are vital to laying the foundations for formal education. To provide our learners ample opportunities to explore, discover, experiment and enjoy, different activities and games form the core of our curriculum. Every activity provides a way for children to build their understanding of new concepts. Through play, they discover the world and learn how things work as they explore and investigate. Children develop skills such as memory, perception, problem-solving, thinking skills etc. There is no better way children learn to socialize than during play as well as develop language skills. It is an excellent way to safely express their feelings and make sense of their world while playing. Various activities are conducted to engage the Pre- Primary learners to explore and experiment. The learners enjoy sand play, nature walk and outdoor play to enhance their motor skills and social skills.</p>

<p>Children are provided the materials to engineer and build three-dimensional solutions. Opportunities for drawing and painting and access to an assortment of materials and the freedom for safe exploration spark creative thinking and problem solving.</p>  
<p>The primary curriculum is designed to address the following-</p>  
<p><strong> Language and Literacy Development – </strong>Language development is crucial at the Pre-Primary as it lays the foundation for later learning. Language development involves listening skills & vocabulary development; pre literacy skills such as phonics & sentences. Hearing new vocabulary spoken helps prepare children to identify unfamiliar words from context, as well as increase their overall phonological awareness. </p>
<p>The Alphabet is taught using Jolly phonics with actions emphasizing on the sounds of the letters. The letter formation and word formations are done through rainbow writing, tracing on varied things such as sand, flour and paint. Activities such as poem recitation, assemblies, show and tell related to colours, numbers, concepts etc. are carried out on a regular basis. Story sessions are regularly conducted to enhance the vocabulary and the listening skills of the learners. Word Webs and Augmented reality are incorporated to tickle their curiosity and bring the world to the classroom. </p>  
<p><strong>Cognitive Development : </strong> To help children to develop their cognitive skills, focus on creating an environment where a child feels comfortable asking questions about the world and the processes that govern it. Asking open-ended questions also encourages a sense of exploration, critical thinking observation and problem solving.</p>  
<p>Pre-mathematical concepts such as heavy or light etc. with quantification and association are taken at varied stages. Activities such as colour/number hopscotch, addition relay race number bingo are also conducted.</p>

<p>Emphasis is also laid to providing experiences to the learners relating the concepts done with the real world. Displays and pretend play related to transport, seasons, camping, culinary delights are conducted. The learners are taken for visiting different places such as grocery shop, Mother Dairy and parks to provide experiential learning. </p>  

<p><strong>Physical and Motor Development - </strong>Physical and Motor Development skills are essential to healthy growth and development and success in school. Motor development focuses on small (turning pages, holding a crayon, building with legos, cutting with scissors) and large (crawling, running, bouncing a ball) movement skill.</p>
<p>Activities such as lemon race, hopscotch activities, music and movement etc. are integral part of the curriculum. Brain breaks, yoga and simple activity of enjoying on the school grounds are taken up. To enhance fine motor skills, activities such potato peeling, shelling peas, lacing, peg board puzzles, colouring, painting, paper crumpling and craft activities are encouraged.</p>  
<p><strong>Social and Emotional Development - </strong> Success in school is not just about academics. It’s also about developing the skills to relate to peers and educators. Social and emotional development means how children start to understand who they are, what they feel and what to expect when interacting with others. It is the development of being able to form and sustain positive relationships, experience, manage and express emotions and explore and engage with the environment. </p>  
<p>Circle time and free play are important aspects of the day. The learners are provided time to play anything of their choice thus providing them an opportunity to take decisions as well as interact with their peers. Circle time provides them an opportunity to share their thoughts, experiences and simply be a part of the class community. Celebrations on various festivals as well as events are conducted to foster a sense of community. </p>  */}

              <h3>Preparatory (Classes 3 to 5)</h3>
              <h3>Curriculum Overview: Planting Roots for Lifelong Learning</h3>
              <p>
                At Lotus Valley International School, Noida Extension, the
                Primary Wing provides a nurturing environment that empowers each
                student to discover their strengths and rediscover the joy of
                learning. With a focus on 21st-century skills, the school
                follows an integrated, inquiry-based, and experiential approach
                that supports holistic development in line with the National
                Curriculum Framework (NCF) 2023. Our learning framework is
                thoughtfully designed to nurture young learners intellectually,
                socially, emotionally, and physically. It integrates
                age-appropriate academic learning with creative expression,
                hands-on exploration, and values-based education. Emphasizing
                inquiry, collaboration, and conceptual understanding, the
                curriculum encourages students to become confident
                communicators, critical thinkers, and compassionate individuals.
                Joyful, engaging, and inclusive education nurtures curiosity,
                creativity, and critical thinking among young learners.
              </p>
              <h3>Language and Literacy Development</h3>
              <p>
                Language development at the preparatory stage focuses on
                building strong literacy, comprehension, and communication
                skills—forming the foundation for confident self-expression and
                future readiness. Through a variety of meaningful experiences
                such as storytelling sessions, author visits, newspaper reading,
                and age-appropriate speaking and listening activities, children
                are encouraged to engage actively with both Hindi and English.
              </p>
              <p>
                As part of the curriculum framework, students in Grade V are
                also offered a choice of third languages such as German, French,
                Spanish, or Sanskrit, fostering multilingualism, early
                international exposure, and global awareness. These
                well-integrated activities spark curiosity, strengthen
                vocabulary, and promote critical thinking. Opportunities to
                share ideas through discussions, role-plays, and creative
                expression help develop fluency and clarity in both verbal and
                written forms. The school's holistic approach nurtures confident
                readers, thoughtful listeners, and expressive
                communicators—equipped to thrive in an ever-evolving world.
              </p>
              <h3>Cognitive Development and Foundational Numeracy</h3>
              <p>
                At the preparatory stage, there is a strong emphasis on
                foundational numeracy, as envisioned by the National Education
                Policy (NEP) 2020 and reinforced by the NCF 2023. Our school
                adopts a child-centric, experiential, and inclusive approach,
                ensuring that students acquire these skills through meaningful,
                play-based, and activity-driven experiences.
              </p>
              <p>
                Interactive math games, manipulatives, puzzles, and real-life
                problem-solving activities lay the groundwork for numeracy.
                Continuous assessments, along with targeted support and
                interventions, help monitor individual progress and ensure that
                no child is left behind. By nurturing curiosity, confidence, and
                competency-based learning, we aim to lay a strong and joyful
                foundation for lifelong academic growth.
              </p>
              <p>
                Through interdisciplinary projects, students develop essential
                knowledge, skills, values, and attitudes—laying a strong
                foundation to understand and navigate the real world with
                confidence and purpose. Aligned with the Sustainable Development
                Goals, the project presentations for Grades III to V are
                centered around the theme 'The World Around Us', encouraging
                learners to explore and understand their natural, social, and
                cultural environments. Key themes such as family, food, shelter,
                water, travel, plants, animals, and community living help
                children make meaningful connections, develop environmental
                awareness, and grow into responsible and empathetic individuals.
              </p>
              <h3>Physical and Motor Development</h3>
              <p>
                By engaging in age-appropriate physical activities, children
                enhance gross and fine motor coordination, develop balance and
                body control, and build healthy lifestyle habits from an early
                age. Play-based learning, structured games, and regular sports
                sessions help strengthen physical endurance, teamwork, and
                self-discipline. Alongside school-based programs, community
                fitness initiatives and awareness sessions on health and hygiene
                foster a culture of wellness beyond the classroom. These efforts
                ensure that children grow into physically active, mindful, and
                health-conscious individuals—ready to lead balanced lives both
                in and outside of school.
              </p>
              <h3>Socio-Emotional Development</h3>
              <p>
                Aligned with the goals of the NCF to ensure holistic
                development, character building, and emotional well-being, the
                socio-emotional domain in our school fosters empathy,
                resilience, and strong interpersonal skills. Daily dedication
                and positive affirmations nurture self-awareness and a positive
                mindset, while mindful morning prayers offer moments of
                connection, reflection, and gratitude.
              </p>
              <p>
                Through daily classroom interactions, value-based discussions,
                storytelling, reflective practices, and co-curricular
                activities, learners are encouraged to develop integrity,
                empathy, respect, responsibility, and resilience. Our Impact
                Program plays a crucial role in addressing learning gaps by
                building strong teacher-student connections, engaging students
                in personalized activities, and consistently reinforcing
                positive behaviour—thus creating a supportive and inclusive
                learning environment in line with the NCF's vision of joyful and
                meaningful education.
              </p>
              <p>
                Rich cultural experiences are further enhanced through morning
                assemblies, guest speaker sessions, club activities, and student
                showcases—allowing learners to appreciate the world around them
                and grow into environmentally responsible and culturally
                sensitive individuals.
              </p>
              <h3>Creative and Aesthetic Development</h3>
              <p>
                Imagination is a child's earliest way of making sense of the
                world, and creativity is the language through which they express
                it. Our curriculum nurtures this natural spark by offering rich
                opportunities in visual art, music, storytelling, movement, and
                dramatic play.
              </p>
              <p>
                Hands-on experiences such as clay modelling, collage making, and
                group performances foster fine motor skills and teamwork. Rooted
                in the principles of NEP 2020 and NCF 2023, this creative
                approach helps children become expressive, observant, and
                culturally aware learners who find joy in diverse forms of
                expression.
              </p>
              <p>
                These experiences encourage originality, confidence in
                self-expression, and a willingness to explore new perspectives.
                By engaging with their senses, emotions, and ideas, learners
                cultivate a lasting connection with creativity—one that fuels
                innovation, curiosity, and joy throughout their lives.
              </p>
              <p>
                Within these expressive spaces, children develop essential
                creative abilities such as divergent thinking, visual-spatial
                understanding, symbolic expression, and a deep appreciation for
                aesthetics.
              </p>
              <h3>Progress Pathways</h3>
              <p>
                Our assessment approach includes assessment as learning,
                assessment for learning, and assessment of learning. Project
                Presentations serve as effective formative and summative
                assessment tools in the primary curriculum, enabling learners to
                demonstrate understanding through real-life application,
                critical thinking, creativity, and collaboration
              </p>

              <h3>Middle (Classes 6 to 8)</h3>
              <h3>
                Fostering Holistic, Experiential, and Future-Ready Learning
              </h3>
              <p>
                At Lotus Valley International School, Noida Extension, the
                Middle School curriculum is thoughtfully designed in line with
                the NEP 2020 and NCF 2023 to foster{" "}
                <b>
                  inquiry, creativity, critical thinking, and lifelong learning.
                </b>{" "}
                It emphasizes <b>skill-based and experiential learning,</b>{" "}
                ensuring that students not only understand concepts but also
                apply them meaningfully in real-life contexts. The curriculum is
                deeply <b>interdisciplinary,</b>allowing learners to make
                connections across subjects and explore themes like
                sustainability, innovation, and global citizenship through
                integrated projects, often aligned with the{" "}
                <b>UN Sustainable Development Goals (SDGs)</b>. Learning is{" "}
                <b>application-based,</b> promoting hands-on activities, lab
                work, design challenges, and real-world simulations.{" "}
                <b>Enquiry-based learning</b> encourages students to ask
                questions, investigate problems, and construct knowledge
                actively. The programme also follows a{" "}
                <b>competency-based approach, </b>where assessment focuses on
                conceptual clarity, skills, and attitudes rather than rote
                memorization. Students maintain <b>portfolios</b> capturing
                their growth through projects, reflections, performances, and
                achievements across domains. Life at school also focuses
                strongly on <b>life skills education,</b> embedding values like
                resilience, empathy, collaboration, ethical reasoning, time
                management, and responsible decision-making into daily
                experiences. Through theatre, storytelling, role-play, and
                discussions, students build <b>social-emotional competence</b>{" "}
                and confidence.{" "}
                <b>Digital literacy, communication, and problem-solving</b> are
                cultivated through Computer Applications and the{" "}
                <b>innovative STEAM Lab,</b> where learners engage in coding,
                robotics, and design thinking. Rich opportunities in art, music,
                MUNs, sports, and Olympiads empower students to explore their
                interests. This holistic, learner-centric curriculum ensures
                that every child grows into a{" "}
                <b>skilled, self-aware, and future-ready individual.</b>{" "}
              </p>
              <ul>
                <h3>Subjects Offered </h3>
                <li>
                  <strong>English & Hindi (Languages):</strong> Emphasis is
                  placed on the four foundational skills—Listening, Speaking,
                  Reading, and Writing (LSRW). Students engage with a variety of
                  texts, develop vocabulary, comprehension, creative expression,
                  and oral communication through debates, drama, storytelling,
                  and collaborative tasks. Language learning is immersive and
                  context-based, enabling learners to become effective and
                  empathetic communicators.
                </li>
                <li>
                  <strong>Third Language (Sanskrit / French / German): </strong>
                  In line with NEP's multilingualism approach, students opt for
                  a third language that introduces them to new linguistic
                  structures, cultural diversity, and functional language use,
                  fostering cognitive flexibility and global awareness.
                </li>
                <li>
                  <strong>Mathematics: </strong>The curriculum emphasizes
                  conceptual clarity, reasoning, problem-solving, and real-life
                  application. Topics such as numbers, operations, patterns,
                  data handling, measurement, and geometry are explored through
                  hands-on activities, games, visual models, and project work,
                  nurturing mathematical thinking and confidence.{" "}
                </li>
                <li>
                  <strong>Science :</strong> With a focus on developing
                  scientific temperament, students explore natural phenomena
                  through observation, experimentation, analysis, and
                  reflection. The curriculum promotes inquiry-based learning and
                  aims to connect concepts with real-world issues like
                  environment, health, and technology, preparing students to
                  apply knowledge for societal good.
                </li>
                <li>
                  <strong>Social Science (History, Civics, Geography):</strong>{" "}
                  Social Science fosters awareness of India's heritage,
                  constitutional values, social structures, and global
                  interdependence. Students critically examine historical
                  events, civic institutions, and geographical patterns while
                  exploring themes like democracy, sustainability, and
                  citizenship through discussions, fieldwork, and simulations.
                </li>
                <li>
                  <strong>
                    Computer Applications: (History, Civics, Geography):
                  </strong>{" "}
                  Aligned with the digital fluency goals of NEP 2020, students
                  gain exposure to ,
                  <b>
                    computational thinking, basic programming, productivity
                    tools, internet safety,
                  </b>{" "}
                  and <b>digital communication.</b> The curriculum integrates{" "}
                  <b>21st-century skills</b> through projects in{" "}
                  <b>coding, design, multimedia creation,</b> and now also
                  introduces <b>Artificial Intelligence (AI)</b> concepts at an
                  age-appropriate level. Students explore how AI works, its
                  real-world applications, and ethical considerations, helping
                  them understand emerging technologies and their impact. This
                  empowers learners to become{" "}
                  <b>
                    digitally literate, responsible, and future-ready citizens
                  </b>{" "}
                  in a rapidly evolving digital world.
                </li>
              </ul>

              <p>
                Each subject is taught with a focus on experiential learning,
                integration with real-life contexts, and reflective thinking,
                helping students become curious, capable, and future-ready
                learners in a rapidly changing world.
              </p>

              <h3>Secondary (Classes 9 to 12)</h3>
              <p>
                At the Senior School level, the curriculum at Lotus Valley
                International School, Noida Extension is aligned with the
                recommendations of the{" "}
                <b>National Education Policy (NEP) 2020</b> and the{" "}
                <b>
                  National Curriculum Framework for School Education (NCF-SE)
                  2023.
                </b>{" "}
                This phase represents a transformative journey for students as
                they deepen academic understanding, make informed subject
                choices, and develop competencies essential for higher education
                and life beyond school.
              </p>
              <h3>Holistic and Multidisciplinary Learning</h3>
              <p>
                The Senior School curriculum fosters academic excellence,
                critical thinking, and personal growth through an integrated,
                flexible, and learner-centric approach. While academic rigour is
                gradually enhanced, equal emphasis is placed on developing
                essential life skills, values, and emotional intelligence.{" "}
              </p>
              <p>
                With the NEP’s emphasis on flexibility, students are encouraged
                to pursue multidisciplinary combinations, nurturing both depth
                and breadth of knowledge. Subjects are no longer viewed in silos
                of Commerce, Science, or Humanities but as interconnected
                domains supporting a holistic understanding of the world.
                Learners at LVISNE can blend core subjects with a wide range of
                skill-based and vocational courses, enabling them to explore and
                excel in diverse areas of interest.
              </p>

              <h3>Academic Subjects (Grades IX–XII) </h3>
              <p>
                Our curriculum offers a broad spectrum of subjects, allowing
                students to design combinations best suited to their interests,
                aptitudes, and career aspirations—free from traditional
                “streams” or fixed subject groupings.
              </p>
              <ul>
                <li>
                  <strong>Languages: </strong>Focus on Listening, Speaking,
                  Reading, and Writing (LSRW) skills to enhance language
                  fluency, literary appreciation, and effective communication.
                </li>
                <li>
                  <strong>Mathematics: </strong>Emphasis on reasoning,
                  abstraction, real-life application, and advanced
                  problem-solving. Students may opt for Standard or Applied
                  Mathematics as per their proficiency and career pathway.
                </li>
                <li>
                  <strong>Sciences: </strong>Inquiry-based learning, conceptual
                  clarity, and hands-on experimentation, encouraging application
                  of scientific knowledge to real-world problems.{" "}
                </li>
                <li>
                  <strong>Social Sciences: </strong> Understanding history,
                  political science, economics, and related disciplines to help
                  students become informed, responsible citizens.
                </li>
                <li>
                  <strong>Applied Disciplines: </strong>Subjects such as
                  Accountancy, Business Studies, Legal Studies, Psychology, and
                  Applied Mathematics, focusing on entrepreneurship, financial
                  literacy, civic awareness, and human behaviour.
                </li>
                <li>
                  <strong>Technology & Innovation: </strong>Computer Science,
                  Artificial Intelligence, and other emerging technology courses
                  fostering computational thinking, programming, data handling,
                  and ethical use of technology.
                </li>
                <li>
                  <strong>Skill-based Electives: </strong>Courses such as
                  Fashion Studies, Entrepreneurship, Yoga, and Physical
                  Education that provide exposure to real-world career skills
                  and align with students’ passions and future goals.
                </li>
              </ul>

              <p>
                This integrated approach enables learners to blend subjects
                across domains, promoting both depth and breadth of knowledge
                while supporting personalised learning journeys.
              </p>

              <h3>21st Century Skills and Competency Development</h3>
              <p>
                Our curriculum goes beyond textbooks. It prepares students to
                become problem-solvers, collaborators, and innovative thinkers
                through:
              </p>
              <ul>
                <li>
                  Project-based learning tied to real-world issues and the UN
                  Sustainable Development Goals (SDGs)
                </li>
                <li>Digital literacy, integrated across all subjects</li>
                <li>
                  Life skills education, including decision-making, stress
                  management, empathy, and leadership
                </li>
                <li>
                  Guidance and counselling sessions which support career
                  planning and informed subject choices
                </li>
                <li>
                  Student Exchange Programmes foster cross-cultural
                  collaboration, enabling students to engage with global peers,
                  share ideas, and learn through diverse perspectives
                </li>
              </ul>

              <h3>Assessment Philosophy</h3>
              <p>
                In keeping with NCF-SE 2023, assessments go beyond rote recall.
                The school adopts a comprehensive, competency-based assessment
                approach including:
              </p>
              <ul>
                <li>
                  Formative assessments that promote feedback for learning
                </li>
                <li>Summative evaluations aligned with CBSE patterns</li>
                <li>
                  Portfolios and student-led reflections to track progress over
                  time
                </li>
                <li>
                  Oral presentations, peer reviews, and projects that emphasize
                  application and articulation
                </li>
              </ul>
              <h3>Co-curricular Excellence</h3>
              <p>
                <b>
                  Learning at LVISNE is deeply enriched by co-curricular
                  opportunities:
                </b>
              </p>
              <ul>
                <li>
                  <strong>Visual and Performing Arts:</strong> Classical and
                  contemporary art, music, dance, and theatre.
                </li>
                <li>
                  <strong>Sports and Fitness Programmes</strong> that build
                  physical strength, discipline, and team spirit.
                </li>
                <li>
                  <strong>Clubs and Societies:</strong> From MUN, literary,
                  culinary, and STEAM clubs to debating and entrepreneurship.
                </li>
                <li>
                  <strong>Social Outreach</strong> through community engagement,
                  campaigns, and service-learning projects.
                </li>
              </ul>
              <p>
                At <b>Lotus Valley International School, Noida Extension,</b>{" "}
                the Senior School curriculum is not just preparation for board
                examinations—<b>it is preparation for life.</b>
              </p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Curriculum;
